import { isEmpty } from "lodash";

import { calculateYield } from "@/shared/utils/calculateYield";
import { FunnelTotal, Layer } from "@/Utils/hierarchy";
import { getMappedName } from "@/Utils/mapping-utils";

import { BaseData, SharedRevenueChannelTotalROIMap } from "../../types";
import { ChannelTotalROIMap } from "../../types";
import { RoiData } from "../getRois";
import { SharedRevenue } from "../../helpers/getMetrics";

const funnels = [FunnelTotal.Total, Layer.Brand, Layer.Category, Layer.Product] as const;

const getYield = (data: BaseData) =>
  Object.fromEntries(
    funnels.map((funnel) => [
      funnel,
      calculateYield(
        "spend" in data ? data.spend[funnel] : undefined,
        "revenue" in data ? data.revenue[funnel] : undefined
      ),
    ])
  );

const mapNodes = (channels: ChannelTotalROIMap | SharedRevenueChannelTotalROIMap) =>
  Object.fromEntries(
    Object.entries(channels).map(([key, value]) => [
      getMappedName(key) || key,
      {
        ...value,
        channel: getMappedName(value.channel) || value.channel,
        id: getMappedName(value.id) || value.id,
        yield: getYield(value),
      },
    ])
  );

export const selectRois = (data: RoiData[]) => {
  if (isEmpty(data)) return data;
  return data.map((node) => ({
    ...node,
    aggregated: mapNodes(node.aggregated),
    split: mapNodes(node.split),
  })) as RoiData[];
};

export const selectSharedRevenue = (data: SharedRevenue) => {
  if (isEmpty(data)) return data;
  return {
    ...data,
    aggregated: mapNodes(data.aggregated),
    split: mapNodes(data.split),
  };
};
